export default __webpack_public_path__ + "static/media/cheetah.17c6e71d.png";